export default function makeMessage(error) {
  if ( !error ) {
    return
  }

  // A pre-built message descriptor (e.g. from a component's locale.js)
  // is translatable, so we hand it back for <FormattedMessage> to
  // resolve against the locale catalog.
  if ( error.defaultMessage && error.id ) {
    return error
  }

  // Anything else is adhoc error text — typically a Stripe error that
  // the payment provider has already localized to the user's language.
  // There is no catalog entry to look up, so we return the raw string
  // for the caller to render verbatim. Synthesizing a message id from
  // the text and routing it through <FormattedMessage> only logs
  // MISSING_TRANSLATION while rendering the very same text.
  const message = error.message || error

  if ( typeof message !== 'string' ) {
    return
  }

  return message
}
